import React, { useEffect } from 'react'
import { X, ChevronRight, FileText, Lock } from 'lucide-react'


export default function SideDrawer({ 
  isOpen, 
  onClose, 
  title, 
  items, 
  onItemClick, 
  isLocked = false 
}) {
  useEffect(() => {
    const handleOutsideClick = (e) => {
      const drawer = document.getElementById('side-drawer')
      if (isOpen && drawer && !drawer.contains(e.target)) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick)
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [isOpen, onClose])

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40" aria-hidden="true" />
      )}
      <div
        id="side-drawer"
        className={`fixed inset-y-0 right-0 w-auto  bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } z-50`}
      >
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
            aria-label="Close drawer"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="overflow-y-auto h-full pb-20 ">
          {items?.map((item, index) => (
            <button
              key={item.id}
              className="w-full gap-4 text-left px-4 py-3 flex items-center justify-between hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
              onClick={() => onItemClick(item, index)}
            >
              <span className="flex-grow">{`${item?.chapter_no}(${item?.chapter})`}</span>
              <div className="flex items-center space-x-2">
                {isLocked && index > 1 && <Lock className="w-5 h-5 text-gray-400" />}
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </>
  )
}